'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscussionEmbed = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiscussionEmbed = exports.DiscussionEmbed = function (_React$Component) {
    _inherits(DiscussionEmbed, _React$Component);

    function DiscussionEmbed() {
        _classCallCheck(this, DiscussionEmbed);

        return _possibleConstructorReturn(this, (DiscussionEmbed.__proto__ || Object.getPrototypeOf(DiscussionEmbed)).apply(this, arguments));
    }

    _createClass(DiscussionEmbed, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (typeof window !== 'undefined' && window.disqus_shortname && window.disqus_shortname !== this.props.shortname) this.cleanInstance();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadInstance();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (this.props.shortname !== nextProps.shortname) return true;

            var nextConfig = nextProps.config;
            var config = this.props.config;
            if (nextConfig.url === config.url || nextConfig.identifier === config.identifier) return false;
            return true;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (this.props.shortname !== nextProps.shortname) this.cleanInstance();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.loadInstance();
        }
    }, {
        key: 'loadInstance',
        value: function loadInstance() {
            var doc = window.document;
            if (window && window.DISQUS && doc.getElementById('dsq-embed-scr')) {
                window.DISQUS.reset({
                    reload: true,
                    config: this.getDisqusConfig(this.props.config)
                });
            } else {
                window.disqus_config = this.getDisqusConfig(this.props.config);
                window.disqus_shortname = this.props.shortname;
                (0, _utils.insertScript)('https://' + this.props.shortname + '.disqus.com/embed.js', 'dsq-embed-scr', doc.body);
            }
        }
    }, {
        key: 'cleanInstance',
        value: function cleanInstance() {
            var doc = window.document;
            (0, _utils.removeScript)('dsq-embed-scr', doc.body);
            if (window && window.DISQUS) window.DISQUS.reset({});

            try {
                delete window.DISQUS;
            } catch (error) {
                window.DISQUS = undefined;
            }
            var disqusThread = doc.getElementById('disqus_thread');
            if (disqusThread) {
                while (disqusThread.hasChildNodes()) {
                    disqusThread.removeChild(disqusThread.firstChild);
                }
            }
        }
    }, {
        key: 'getDisqusConfig',
        value: function getDisqusConfig(config) {
            return function () {
                this.page.identifier = config.identifier;
                this.page.url = config.url;
                this.page.title = config.title;
                this.callbacks.onNewComment = [config.onNewComment];
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { id: 'disqus_thread' });
        }
    }]);

    return DiscussionEmbed;
}(_react2.default.Component);


//////////////////
// WEBPACK FOOTER
// ./~/disqus-react/lib/DiscussionEmbed.js
// module id = 361
// module chunks = 107818501498521